(function () {
    "use strict";

    angular.module('app').directive('slider', SliderDirective);
    SliderDirective.$inject = ['$timeout'];
    function SliderDirective($timeout) {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: false,
            scope: {
                value: '=',
                trueTranslation: '@',
                falseTranslation: '@',
                isReadOnly: '=?',
                defaultRed: '=',
                onValidated: '=?',
                objectToTransfer: '=',
                setSmallSize: '='
            },
            template: `
                <div>
                    <div class="row">
                        <div class="">
                            <label
                                style="position: relative;top: 5px;" ng-style="{ cursor: isReadOnly ? 'not-allowed' : 'pointer' }"
                                ng-click="setValue(false)">{{ falseTranslation }}</label>&nbsp; &nbsp;
                            <label class="switch" ng-class="GetSliderSize()">
                                <input type="checkbox" ng-model="value">
                                <span class="slider round" ng-style="GetStyle()"></span>
                            </label>&nbsp; &nbsp;
                            <label
                                style="position: relative;top: 5px;" ng-style="{ cursor: isReadOnly ? 'not-allowed' : 'pointer' }"
                                ng-click="setValue(true)">
                                {{ trueTranslation }}
                            </label>
                        </div>
                    </div>
                </div>`
            ,
            link: function ($scope, element) {
                const toggle = $(element).find('input[type=checkbox]')[0];

                $scope.setIsIndeterminate = (indeterminate) => {
                    $(toggle)[0].indeterminate = indeterminate;
                };

                if (true && $scope.value) {
                    $(toggle).prop('checked', true);
                    $scope.setIsIndeterminate(false);
                } else if ($scope.value === undefined || $scope.value === null) {
                    $scope.setIsIndeterminate(true);
                } else {
                    $(toggle).prop('checked', false);
                    $scope.setIsIndeterminate(false);
                }

                if (true && $scope.isReadOnly)
                    $(toggle).prop('disabled', true);
                else
                    $(toggle).prop('disabled', false);

                $scope.isIndeterminate = () => $(toggle)[0].indeterminate;

                $scope.setValue = (v) => {
                    if ($scope.isReadOnly) return;
                    $scope.setOnScope = true;

                    updateValue(v);
                    $(toggle).prop('checked', v);
                };

                $scope.executeOnSet = executeOnSet;

                function executeOnSet(value) {
                    if (angular.isFunction($scope.onValidated)) {
                        // Delay the callback until the next digest cycle, otherwise the data on the object is not updated
                        // The reason for this is that while we update $scope.value, this does not necessarily happen before 
                        // a digest cycle is active. Therefore it needs to be triggered in the next cycle (to make sure).
                        $timeout(() => $scope.onValidated(value, $scope.objectToTransfer));
                    }
                }

                $(toggle).attr('checked', true).change(function () {
                    $scope.setOnScope = true;
                    updateValue(this.checked);
                });

                function updateValue(v) {
                    $scope.value = v;

                    if ($scope.setOnScope) {
                        $scope.setIsIndeterminate(false);
                        $scope.executeOnSet($scope.value);
                        $scope.setOnScope = false;
                    }
                }

                $scope.$watch('isReadOnly', (newV) => $(toggle).prop('disabled', newV));
                $scope.$watch('value', (newV, oldV) => {
                    if (newV === undefined || newV === null || (newV === oldV)) return;
                    updateValue(newV);
                    $scope.setIsIndeterminate(false);
                });
                $scope.GetClass = () => (!$scope.defaultRed) ? 'slider-default' : '';
                $scope.GetStyle = () => {
                    let style = { 'cursor': 'pointer' };
                    if ($scope.isReadOnly)
                        style = { 'cursor': 'not-allowed', 'background-color': 'rgb(119 119 119 / 35%)' };
                    return style;
                };
                $scope.GetSliderSize = () => $scope.setSmallSize ? "slider-80percent" : "";
            },
        };
    }
})();